
import React, {Component} from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

var stateManager = require('../../utils/state/stateManager.js');
var screenKeyboardAction = require('../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');

class KeyboardComponent extends Component
{
    constructor(props) 
    {
        super(props); 

        this.handleShift = this.handleShift.bind(this);
        this.handleCaps = this.handleCaps.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyboardRef = this.onKeyboardRef.bind(this);

        this.state = 
        {
            isShiftOn: this.props.isShiftOn,
            isCapsOn: this.props.isCapsOn,
            initialValue: this.props.initialValue
        }

        this.focusRef = React.createRef();
    }

    componentWillReceiveProps(nextProps)
    {
        this.state.initialValue = nextProps.initialValue;
    }

    componentWillUnmount()
    {
        this.keyboard.destroy();
        document.removeEventListener("mousedown", () => {});
    }

    componentDidMount() 
    {
        document.addEventListener("mousedown", (e) => {
            if (this.focusRef.current?.contains(e.target)) {
                e.preventDefault();
            }
        })
    }
    

    handleShift() 
    {
        this.state.isShiftOn = !this.state.isShiftOn;
        this.setState({});
    };

    handleCaps()
    {
        this.state.isCapsOn = !this.state.isCapsOn;
        this.setState({});
    };

    onChange(input) 
    {
        if (this.props.onScreenKeyboardContext.onKeyDown != null)
                this.props.onScreenKeyboardContext.onKeyDown(input);

        this.keyboard.setInput("");
    };

    onKeyPress(button)
    {
        this.keyboard.setInput("");
        
        if (button === "{shift}") 
        {
            this.handleShift();
            return;
        }
        if (button === "{standard}") 
        {
            this.handleShift();
            return;
        }

        if (button === "{lock}") 
        {
            this.handleCaps();
            return;
        }

        if (button === "{bksp}")
        {
            if (this.props.onScreenKeyboardContext.onBackspace != null)
                this.props.onScreenKeyboardContext.onBackspace();
            return;
        }

        if (button === "{ok}")
        {
            if (this.props.onScreenKeyboardContext.onEnter != null)
                this.props.onScreenKeyboardContext.onEnter();
            else
                stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
            return;
        }

        if (button === "{hide}")
        {
            stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
            return;
        }
    };

    onKeyboardRef(r)
    {
        this.keyboard = r;
    }

    

    render()
    {
        let layout = "caps";
        if (this.state.isShiftOn)
        {
            layout = "shift";
        }
        else
        {
            layout = this.state.isCapsOn ? "capsOn" : "standard";
        }
        return (
                <div id="win-keyboard" ref={this.focusRef} style={{color:'#303030'}} tabIndex={-1} onBlur={()=>
                {
                    stateManager.getStore().dispatch(screenKeyboardAction.createAction(null))
                }}>
                    <Keyboard 
                    key="editor1"
                        keyboardRef={this.onKeyboardRef}
                        layoutName={layout}
                        onChange={this.onChange}
                        onKeyPress={this.onKeyPress}
                        theme='hg-theme-default standard-keyboard'

                        buttonTheme={[
                            {
                                class: "keyboard-standard-keys",
                                buttons: "A B C D E F G H I J K L M " + 
                                         "N O P Q R S T U V W X Y Z " + 
                                         "a b c d e f g h i j k l m n o p q r s t u v w x y z " + 
                                         "0 1 2 3 4 5 6 7 8 9 {bksp} {ok} {hide} {lock} {shift} {standard} {space} {ok} " +
                                         "~ ! @ # $ £ % ^ & * ( ) + : ; . ? < > \" ' ,"
                            },
                        ]}

                        display={
                            {
                                "{bksp}": "Backspace",
                                "{ok}": "Enter",
                                "{shift}": ".?123",
                                "{space}": " ",
                                "{tab}": "⇥",
                                "{lock}": "Caps Lock",
                                "{hide}": "Hide",
                                "{standard}": "ABC",
                            }
                        }
                        
                        layout={{
                            standard: this.props.standardLayout,
                            shift: this.props.shiftLayout,
                            capsOn: this.props.capOnLayput
                          }}>
                    </Keyboard>
                </div>
               );
    }
}

export default KeyboardComponent;